import _ from 'lodash';
import $ from 'jquery';
import AppDispatcher from '../dispatcher/AppDispatcher';
import Constants from '../constants/Constants';

const ActionTypes = Constants.ActionTypes;

const requestApi = function (data, path) {
  const url = _.get(globals, 'apiWebroot', '/') + path;

  return $.ajax({
    type: 'GET',
    url,
    data,
    dataType: 'json',
  });
};

module.exports = {
  // galerijas datu ielāde
  galleryLoad(memberId, gotoImage, eventId) {
    // load
    AppDispatcher.dispatch({
      type: ActionTypes.GALLERY_LOAD,
    });
    let data = {
      member: memberId
    };

    if (eventId) {
      data.event = eventId;
    }

    const request = requestApi(data, 'images/get_gallery');

    // success
    request.done((data) => {
      // pievieno lietotāja datus
      if (!_.isEmpty(data.members)) {
        AppDispatcher.dispatch({
          type: ActionTypes.MEMBERS_LOAD_SUCCESS,
          members: data.members,
        });
      }

      if (!_.isEmpty(data.images)) {
        // pievieno bildes
        AppDispatcher.dispatch({
          type: ActionTypes.GALLERY_LOAD_SUCCESS,
          images: data.images,
          gotoImage, // kuru bildi atvērt
          memberId, // kura lietotāja galerija
        });
      } else {
        AppDispatcher.dispatch({
          type: ActionTypes.GALLERY_LOAD_FAIL,
        });
      }
    });

    // fail
    request.fail((data) => {
      location.reload(true);
      // TODO vajadzētu izvadīt kļūdu paziņojumu
    });
  },

  loadLocal(images, gotoImage) {
    AppDispatcher.dispatch({
      type: ActionTypes.GALLERY_LOAD_SUCCESS,
      images,
      gotoImage, // kuru bildi atvērt
      memberId: null
    });
  },

  // nākošā galerijas bilde
  nextImage() {
    AppDispatcher.dispatch({
      type: ActionTypes.GALLERY_LOAD_NAVIGATION,
      next: true,
    });
  },

  // iepriekšējā galerijas bilde
  prevImage() {
    AppDispatcher.dispatch({
      type: ActionTypes.GALLERY_LOAD_NAVIGATION,
      prev: true,
    });
  },

  // iestate bildi pēc indekss vērtības
  goToImage(index) {
    AppDispatcher.dispatch({
      type: ActionTypes.GALLERY_LOAD_NAVIGATION,
      goTo: true,
      index,
    });
  },

  // iestata bildes ielādēšanas statusu - ok vai error
  loadImage(index, status) {
    AppDispatcher.dispatch({
      type: ActionTypes.GALLERY_LOAD_STATUS,
      loadStatus: status,
      index,
    });
  },

  // Uzliek pazīmi "Patīk" bildei
  likeImage(index, imageId) {
    const data = {
      image_id: imageId,
    };

    const request = requestApi(data, 'images/like');

    // success
    request.done((data) => {
      if (data.status != 'ok') {
        return;
      }

      AppDispatcher.dispatch({
        type: ActionTypes.GALLERY_LIKE_SUCCESS,
        count: data.count,
        index,
      });
    });

    // fail
    request.fail((data) => {
      location.reload(true);
      // TODO vajadzētu izvadīt kļūdu paziņojumu
    });
  },

  // Ziņot par bildi
  reportImage(index, imageId, file) {
    const data = {
      image_id: imageId,
    };

    if (file) {
      data.filename = file;
    }

    const request = requestApi(data, 'images/report.json');

    // success
    request.done((data) => {
      if (data.status != 'ok') {
        return;
      }

      AppDispatcher.dispatch({
        type: ActionTypes.GALLERY_REPORT_SUCCESS,
        index,
      });
    });

    // fail
    request.fail((data) => {
      location.reload(true);
      // TODO vajadzētu izvadīt kļūdu paziņojumu
    });
  },

  // kompliments bildei
  addCompliment(image, message) {
    const imageId = image.get('file_id');
    const index = image.get('index');

    const data = {
      image_id: imageId,
      msg: message,
    };

    AppDispatcher.dispatch({
      type: ActionTypes.GALLERY_COMPLIMENT_SEND,
    });

    const request = requestApi(data, 'images/like_comment');

    // success
    request.done((data) => {
      if (data.status != 'ok') {
        return;
      }

      AppDispatcher.dispatch({
        type: ActionTypes.GALLERY_COMPLIMENT_SUCCESS,
        index,
      });
    });

    // fail
    request.fail((data) => {
      location.reload(true);
      // TODO vajadzētu izvadīt kļūdu paziņojumu
    });
  },
};
